import ToastHighLighter from '@/lib/ToastHighLighter';

export const PaasHeaderCode = () => {
  const language = 'html';
  const codeString = `
  // PAAS-Header
  <div class="navbar-container container flex align-content-center mb-lg-3">
    <Link href="/" legacyBehavior>
      <a class="navbar-brand">
        <img
          src=""
          alt=""
          height=""
          width=""
        />
      </a>
    </Link>

    <button
      class="navbar-toggler position-absolute end-0"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarTogglerDemo03"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span> Menü
    </button>

    <div class="d-lg-flex align-items-center d-none mr-3 meta-nav-wrapper">
      <ul class="nav lang-nav">
        <li>
          <a class="active" href="#">
            DE
          </a>
        </li>
        <li>
          <a href="#">EN</a>
        </li>
      </ul>
      <button
        class="btn btn-secondary d-none d-lg-block search-button"
        data-search-icon=""
        type="button"
      >
        <svg height="20" viewBox="0 0 19 20" width="19">
          <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            transform="translate(1 1)"
          >
            <path
              d="M16.5 17.5l-4-4"
              strokeLinecap="round"
              strokeWidth="3"
            ></path>
            <circle cx="7" cy="7" r="7" strokeWidth="2"></circle>
          </g>
        </svg>
        <span class="sr-only sr-only-focusable">Suchen</span>
      </button>
    </div>
  </div>

  <div class="navbar-banner bg-secondary py-1 w-100">
    <p class="container font-bigger leading-semi">
      FHNW Bootstrap V5 Styleguide
    </p>
  </div>
  `;

  return (
    <>
      <ToastHighLighter
        name={'paas-header'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
